import { IconButton, InputRightElement } from '@chakra-ui/react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';


interface TogglePasswordVisibilityButtonProps {
  visible: boolean;
  onToggle: () => void;
}

const TogglePasswordVisibilityButton: React.FC<TogglePasswordVisibilityButtonProps> = ({
  visible,
  onToggle,
}) => {
  return (
    <InputRightElement h="48px" width={12}>
      <IconButton
        fontSize={16}
        icon={visible ? <MdVisibilityOff /> : <MdVisibility />}
        aria-label="toggle visibility"
        bg="gray.200"
        color="gray.500"
        _hover={{ bg: 'gray.300' }}
        _active={{ bg: 'gray.300' }}
        size="sm"
        onClick={onToggle}
      />
    </InputRightElement>
  );
};

export default TogglePasswordVisibilityButton;
